module.exports = __webpack_public_path__ + "bd50cde8be53aceb176e2a63eae61459.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/settour.jpg
 ** module id = 744
 ** module chunks = 0
 **/